// Supabase configuration utilities

// Suppress time skew warnings in development/production
export const suppressSupabaseWarnings = () => {
  const originalConsoleWarn = console.warn
  console.warn = (...args) => {
    // Filter out specific Supabase time skew warnings
    const message = args.join(' ')
    if (message.includes('@supabase/gotrue-js') && message.includes('Session as retrieved from URL was issued in the future')) {
      // Suppress this specific warning as it's often due to minor clock differences
      return
    }
    originalConsoleWarn.apply(console, args)
  }
}

// Initialize suppression
suppressSupabaseWarnings()